export default __webpack_public_path__ + "static/media/arrow-left.e37fae9f.svg";